module.exports = __webpack_public_path__ + "static/media/do.181cfd7c.svg";